import { useForm, Link } from '@inertiajs/react'
import AuthLayout from '@/layouts/AuthLayout'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'

export default function Register({ errors: serverErrors }) {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: '',
      password: '',
      password_confirmation: '',
    },
  })

  const allErrors = { ...errors, ...serverErrors }

  function handleSubmit(e) {
    e.preventDefault()
    post('/users')
  }

  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>Create an account</CardTitle>
          <p className="text-sm text-muted-foreground">
            Please use your work email. Personal email providers (Gmail, Yahoo, Outlook, etc.) aren't supported.
            We'll send a verification link before your account is active.
          </p>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Work email</Label>
              <Input
                id="email"
                type="email"
                value={data.user.email}
                onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
                autoComplete="email"
                placeholder="you@yourcompany.com"
                autoFocus
              />
              {allErrors?.email && (
                <p className="text-sm text-destructive">{allErrors.email.join(', ')}</p>
              )}
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={data.user.password}
                onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
                autoComplete="new-password"
              />
              {allErrors?.password && (
                <p className="text-sm text-destructive">{allErrors.password.join(', ')}</p>
              )}
            </div>
            <div className="space-y-2">
              <Label htmlFor="password_confirmation">Confirm password</Label>
              <Input
                id="password_confirmation"
                type="password"
                value={data.user.password_confirmation}
                onChange={(e) => setData('user', { ...data.user, password_confirmation: e.target.value })}
                autoComplete="new-password"
              />
              {allErrors?.password_confirmation && (
                <p className="text-sm text-destructive">{allErrors.password_confirmation.join(', ')}</p>
              )}
            </div>
          </CardContent>
          <CardFooter className="flex flex-col gap-4">
            <Button type="submit" className="w-full" disabled={processing}>
              Sign up
            </Button>
            <p className="text-sm text-muted-foreground">
              Already have an account?{' '}
              <Link href="/users/sign_in" className="text-primary underline">
                Sign in
              </Link>
            </p>
          </CardFooter>
        </form>
      </Card>
    </AuthLayout>
  )
}
